//dependencies
import { useAutoAnimate } from "@formkit/auto-animate/react";
import React from "react";

import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";

import Alert from "../../../../../../../components/Alert";
//components
import PageBanner from "../../../../../../../components/PageBanner";

//utils
import { ReviewQuestion } from "../../../utils";

//store
import { useEditFormStore } from "../../../useEditFormStore";

const CalculatorQuestion = ({ data }: { data: ReviewQuestion }) => {
	const [ref] = useAutoAnimate();
	const questionsMap = useEditFormStore((state) => {
		return state?.questions?.reduce((acc, question) => {
			acc[question.refId] = question;
			return acc;
		}, {});
	});

	return (
		<div className="flex flex-col gap-4">
			{data?.is_hidden ? (
				<Alert
					message="This calculation is hidden on review forms for all users"
					type="success"
					className="w-full pt-2"
				/>
			) : (
				<div />
			)}
			<div className="flex flex-col gap-2" ref={ref}>
				{data?.questions?.length ? (
					data.questions.map((question, index) => (
						<div
							key={`${question.refId}-${index}-preview`}
							className="flex flex-col gap-2 rounded-[4px] bg-neutral-1 p-2"
						>
							<p className="line-clamp-2 max-w-full overflow-hidden text-wrap break-words">
								<span className="shrink text-paragraph-3 font-semibold">Question: </span>
								{questionsMap[question.refId]?.question}
							</p>
							<div className="flex items-center gap-2">
								<p className="text-paragraph-3 font-semibold">
									Weight: <span className="font-regular">{question.weight}</span>
								</p>
							</div>
						</div>
					))
				) : (
					<div>
						<PageBanner
							type="error"
							size="medium"
							isDismissible={false}
							icon={faTriangleExclamation}
							title="You do not have any questions selected for this calculation. Please edit or remove this question type in order to continue."
						/>
					</div>
				)}

				{!data?.aggregation && (
					<PageBanner
						type="error"
						size="medium"
						isDismissible={false}
						icon={faTriangleExclamation}
						title="You do not have any aggregation selected for this calculation. Please edit or remove this question type in order to continue."
					/>
				)}
			</div>
		</div>
	);
};

export default CalculatorQuestion;
